import { HEADER_HEIGHT, VERTICAL_MARGIN } from '@/core/constants/layout';

const AVATAR_SIZE = 28;
const VERTICAL_MARGIN_PX = VERTICAL_MARGIN * 8;

// Avatar sits centered in the header bar, well above its bottom border; nudge
// the menu down by that gap so it opens flush against the header bar.
const menuOffsetToHeaderBorder =
	VERTICAL_MARGIN_PX +
	(HEADER_HEIGHT - VERTICAL_MARGIN_PX * 2 - AVATAR_SIZE) / 2 -
	2; // 2px is the magic number to make the menu border flush with the header bar border

export const headerMenuStyles = {
	menuButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},
	avatar: {
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: 'background.paper',
		width: AVATAR_SIZE,
		height: AVATAR_SIZE
	},
	avatarIcon: {
		width: 17
	},
	logoutIcon: {
		width: 18,
		height: 18
	},
	menuList: {
		marginTop: `${menuOffsetToHeaderBorder}px`,

		minWidth: 228,
		maxWidth: 300
	},
	userEmail: {
		px: 2,
		py: 1,
		color: 'text.disabled',
		fontWeight: 400,
		fontSize: '1rem',
		display: 'block',
		wordBreak: 'break-word'
	}
};
